
import order from "@/store/module/order";
import { Component, Vue, Prop } from "vue-property-decorator";
// import Content from "./content.vue";
@Component({
  components: {
    // Content,
  },
})
export default class Dropdown extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public screenData;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public orderData;
  public historyOrderData = {};
  public date = 0;
  public price = "a";
  public role = "a";
  public currency = "a";
  public dateList = [
    { text: "时间", value: '' },
    { text: "时间升序", value: 'asc' },
    { text: "时间降序", value: 'desc' },
  ];
  public priceList = [
    { text: "价格", value: "" },
    { text: "价格升序", value: "asc" },
    { text: "价格降序", value: "desc" },
  ];
  public activeChange(val) {
    if (this.orderData.role_config_id == val) {
      this.orderData.role_config_id = "-1";
    } else {
      this.orderData.role_config_id = val;
    }
  }
  public activeMoneyChange(val) {
    if (this.orderData.coin_config_id == val) {
      this.orderData.coin_config_id = "-1";
    } else {
      this.orderData.coin_config_id = val;
    }
  }
  public openChange() {
    this.historyOrderData = JSON.parse(JSON.stringify(this.orderData));
  }
  public refreshChange() {
    if (JSON.stringify(this.historyOrderData) != JSON.stringify(this.orderData)) {
      this.$emit('getRefreshList');
    }
  }
}
